






import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject, InjectReactive } from 'vue-property-decorator';

// Shared types
import { System } from '@coldtec/cos-types';

/**
 *  Renders a link to open the specifications for the provided system.
 */
@Component
export default class SystmSpecsLink extends Vue {

    @InjectReactive('system')
    private system!: System;

    /**
     *
     *  Provided by the `Systems.vue` file for
     *  opening the specifications of a system.
     *
     *  @param systemGuid The guid of the system to open the specifications for
     *
     */
    @Inject('openSpecs')
    private openSpecs!: (systemGuid: string) => void;

}
